// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-tooltip .tooltip-inner {
  background-color: #EDF5FF !important; /* soft, airy blue */
  color: #475569 !important;            /* dark gray-blue, readable but not black */
  font-size: 0.7rem;
  padding: 8px 12px;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.custom-tooltip .tooltip-arrow::before {
  border-top-color: #EDF5FF !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/TooltipWrapper.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC,EAAE,oBAAoB;EAC1D,yBAAyB,aAAa,2CAA2C;EACjF,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":[".custom-tooltip .tooltip-inner {\n  background-color: #EDF5FF !important; /* soft, airy blue */\n  color: #475569 !important;            /* dark gray-blue, readable but not black */\n  font-size: 0.7rem;\n  padding: 8px 12px;\n  border-radius: 6px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n}\n\n.custom-tooltip .tooltip-arrow::before {\n  border-top-color: #EDF5FF !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
